import {call, put, select} from "redux-saga/effects";
import {commentFailure, commentSuccess} from "features/components/comment-field/reducer";
import {getErrorFromMessage} from "services/utils/utils";
import * as api from "services/api";
import {commentServerDataSelector} from "features/components/comment-field/selectors";

export function* sendCommentSaga({payload}) {
    const {type, id, attachment} = payload;
    const comment = yield select(commentServerDataSelector);
    try {
        yield call([api, api.sendComment], type, id, comment, attachment)
        yield put(commentSuccess());
    } catch (e) {
        console.log(e);
        yield put(commentFailure(getErrorFromMessage(e)));
    }
}